import React from "react";

function Rajasthan(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M1.44214 20.1973H22.4395"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M1.44214 11.6621H4.05864V20.1997H1.44214V11.6621Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M3.6655 11.6625V10.3046C3.6655 10.0922 3.58115 9.88856 3.431 9.73841C3.28085 9.58826 3.0772 9.50391 2.86486 9.50391C2.65251 9.50391 2.44886 9.58826 2.29871 9.73841C2.14856 9.88856 2.06421 10.0922 2.06421 10.3046V11.6625H3.6655Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M2.90649 8.64307V9.51174"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M1.57227 14.1792H8.09258"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M1.57227 17.2329H8.09258"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M1.44214 12.9365H4.05864"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M2.86499 15.749V17.2326"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M5.16699 15.749V17.2326"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M6.99878 15.749V17.2326"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M6.99878 18.6274V20.111"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M5.21973 18.6274V20.111"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M2.81226 18.6274V20.111"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M6.99854 14.1794V13.2322C6.99854 12.9893 6.90206 12.7564 6.73032 12.5846C6.55857 12.4129 6.32564 12.3164 6.08277 12.3164C5.83989 12.3164 5.60696 12.4129 5.43522 12.5846C5.26348 12.7564 5.16699 12.9893 5.16699 13.2322V14.1794H6.99854Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M6.08374 11.6621V12.3147"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M8.09277 12.9365H9.87984V20.111H8.09277V12.9365Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M9.42135 12.9362V11.7928C9.42135 11.654 9.36622 11.5209 9.26808 11.4228C9.16995 11.3247 9.03684 11.2695 8.89806 11.2695C8.75927 11.2695 8.62616 11.3247 8.52803 11.4228C8.42989 11.5209 8.37476 11.654 8.37476 11.7928V12.9362H9.42135Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M8.89844 10.3198V11.2696"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M22.4417 20.1973H19.8252V11.6596H22.4417V20.1973Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M20.2178 11.6625V10.3046C20.2178 10.0922 20.3021 9.88856 20.4523 9.73841C20.6024 9.58826 20.8061 9.50391 21.0184 9.50391C21.2308 9.50391 21.4344 9.58826 21.5846 9.73841C21.7347 9.88856 21.8191 10.0922 21.8191 10.3046V11.6625H20.2178Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M20.9763 8.64307V9.51174"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M22.308 14.1792H15.7903"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M22.308 17.2329H15.7903"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M22.4414 12.9365H19.825"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M21.0181 15.749V17.2326"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M18.7158 15.749V17.2326"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M16.8843 15.749V17.2326"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M16.8843 18.6274V20.111"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M18.6631 18.6274V20.111"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M21.0706 18.6274V20.111"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M16.8843 14.1794V13.2322C16.8843 12.9893 16.9808 12.7564 17.1525 12.5846C17.3242 12.4129 17.5572 12.3164 17.8001 12.3164C18.0429 12.3164 18.2759 12.4129 18.4476 12.5846C18.6193 12.7564 18.7158 12.9893 18.7158 13.2322V14.1794H16.8843Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M17.8 11.6621V12.3147"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M15.7903 20.1108H14.0032V12.9364H15.7903V20.1108Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M14.4614 12.9362V11.7928C14.4614 11.654 14.5166 11.5209 14.6147 11.4228C14.7128 11.3247 14.8459 11.2695 14.9847 11.2695C15.1235 11.2695 15.2566 11.3247 15.3548 11.4228C15.4529 11.5209 15.508 11.654 15.508 11.7928V12.9362H14.4614Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M14.9846 10.3198V11.2696"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M8.37793 12.9365H10.0996H15.5079"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M10.0994 12.9365V11.0396H13.8933V12.6984"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M13.5115 11.0393V9.95089C13.5108 9.54629 13.3499 9.15842 13.0641 8.87209C12.7782 8.58575 12.3906 8.42423 11.986 8.42285C11.5812 8.42423 11.1933 8.58566 10.9071 8.87193C10.6208 9.15819 10.4594 9.54605 10.458 9.95089V11.0393H13.5115Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M12.6496 8.59035V6.49715C12.6554 6.40339 12.6419 6.30944 12.6101 6.22108C12.5782 6.13272 12.5285 6.05183 12.4642 5.98339C12.3998 5.91494 12.3221 5.8604 12.2359 5.82312C12.1497 5.78584 12.0567 5.7666 11.9628 5.7666C11.8689 5.7666 11.7759 5.78584 11.6897 5.82312C11.6035 5.8604 11.5258 5.91494 11.4614 5.98339C11.3971 6.05183 11.3474 6.13272 11.3155 6.22108C11.2836 6.30944 11.2702 6.40339 11.276 6.49715V8.59035C11.502 8.48971 11.7391 8.41594 11.9824 8.37056C12.2119 8.4201 12.4356 8.49377 12.6496 8.59035Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M11.9839 4.99023V5.81966"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
      <path
        d="M12.9883 20.1973V15.4143C12.9883 15.1423 12.8803 14.8814 12.6879 14.6891C12.4956 14.4967 12.2347 14.3887 11.9627 14.3887C11.6907 14.3887 11.4298 14.4967 11.2374 14.6891C11.0451 14.8814 10.937 15.1423 10.937 15.4143V20.1973H12.9883Z"
        stroke="#17142A"
        strokeWidth="0.348028"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoRajasthan = React.memo(Rajasthan);
export default MemoRajasthan;
